module.exports = __webpack_public_path__ + "img/logo_multisensores_Horizontal_Dark2.5dfd428c.png";